/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './morrisjs-chart.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/morrisjs-chart/morrisjs-chart.component';
const styles_MorrisJSChartComponent:any[] = [i0.styles];
export const RenderType_MorrisJSChartComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MorrisJSChartComponent,data:{}});
export function View_MorrisJSChartComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_MorrisJSChartComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-morrisjs-chart',
      ([] as any[]),(null as any),[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).redraw()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_MorrisJSChartComponent_0,RenderType_MorrisJSChartComponent)),i1.ɵdid(245760,
      (null as any),0,i2.MorrisJSChartComponent,[i1.ElementRef],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const MorrisJSChartComponentNgFactory:i1.ComponentFactory<i2.MorrisJSChartComponent> = i1.ɵccf('admin-morrisjs-chart',
    i2.MorrisJSChartComponent,View_MorrisJSChartComponent_Host_0,{type:'type',data:'data',
        xkey:'xkey',ykey:'ykey',ykeys:'ykeys',label:'label',labels:'labels'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL21vcnJpc2pzLWNoYXJ0L21vcnJpc2pzLWNoYXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9tb3JyaXNqcy1jaGFydC9tb3JyaXNqcy1jaGFydC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9tb3JyaXNqcy1jaGFydC9tb3JyaXNqcy1jaGFydC5jb21wb25lbnQudHMuTW9ycmlzSlNDaGFydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhZG1pbi1tb3JyaXNqcy1jaGFydD48L2FkbWluLW1vcnJpc2pzLWNoYXJ0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsMkVBQUE7TUFBQTs7UUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/morrisjs-chart/morrisjs-chart.component.ngfactory.ts